import * as React from 'react';
import { useState } from 'react';
import './ui.css';
import { Button } from './Button';
import { Text } from './Text';
import { useMediaQuery } from './useMediaQuery';

/*
 * RotatePrompt — the board's design space is a wide landscape box, so on a
 * portrait phone the honest fit shrinks it to something unplayable. Rather than
 * clip it, ask for landscape. Dismissible: the (small) board is still behind
 * this, and some people would rather squint than rotate.
 */

export const RotatePrompt: React.FC = () => {
  const [dismissed, setDismissed] = useState(false);
  const portraitPhone = useMediaQuery('(orientation: portrait) and (pointer: coarse)');

  if (!portraitPhone || dismissed) return null;

  return (
    <div className="ui-rotate-prompt">
      <span className="ui-rotate-prompt__icon" aria-hidden="true">
        ⟳
      </span>
      <Text as="div" variant="heading">
        Rotate your device
      </Text>
      <Text as="div" variant="muted" style={{ textAlign: 'center' }}>
        The table is laid out for landscape.
      </Text>
      <Button variant="ghost" size="sm" onClick={() => setDismissed(true)}>
        Continue in portrait
      </Button>
    </div>
  );
};

export default RotatePrompt;
